
export class RelTasTestigo {
    id:number;
    tasacionId:number;
    testigoId:number;
    observaciones:string;
    a:number;
    b:number;
    c:number;
    d:number;
    e:number;
    f:number;
    
    public constructor() {
        this.id = null;
        this.tasacionId = null;
        this.testigoId = null;
        this.observaciones = null;
        this.a = null;
        this.b = null;
        this.c = null;
        this.d = null;
        this.e = null;
        this.f = null;
    }
}